import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { MdCircle } from 'react-icons/md';
import Icon from '@mdi/react';
import { mdiMapMarker } from '@mdi/js';
import { getSiteStatusColor, getSiteH2AStatusMarker } from '../../../utils/api/site';
import { convertUrlsToLinks } from '../../../utils/urlFinder';
import tailwindTheme from '../../../../../../config/tailwind.config';

const SiteStatus = ({ site }) => {
  const [status, setStatus] = useState('');
  const [h2a, setH2a] = useState('');

  useEffect(() => {
    setStatus(site.status);
    setH2a(site.h2a);
  }, [site]);

  const primaryContact = site.contacts?.find((c) => c.id === site.primary_contact_id) || { name: '', phone: '' };

  const [H2AIcon, color] = getSiteH2AStatusMarker(h2a);

  return (
    <div className="flex flex-col">
      <div className="flex flex-row align-middle justify-between">
        <div className="flex justify-start gap-x-10">
          <div className="flex justify-between items-center justify-center">
            <MdCircle size={24} color={getSiteStatusColor(status)} />
            <h3 className="pl-1" style={{ textTransform: 'capitalize' }}>
              {status}
            </h3>
          </div>

          <div className="flex justify-between items-center justify-center">
            <H2AIcon size={25} color={color} />
            <h3 className="pl-1">H2A</h3>
          </div>

          {site.county && (
            <div className="flex justify-between items-center justify-center">
              <Icon path={mdiMapMarker} size={1} color={tailwindTheme.theme.extend.colors['vamos-green1']} />
              <h3 className="pl-1">{site.county} County</h3>
            </div>
          )}

        </div>
      </div>
      {(site.address1 || site.address2 || site.city || site.state || site.zip_code) && (
        <>
          <strong className="pt-8.25">Address</strong>
          <div className="pt-2">
            {site.address1 && site.address1}
            {site.address1 && site.address2 && ', '}
            {site.address2 && site.address2}
            {(site.address1 || site.address2) && ', '}
            {site.city && `${site.city}, `}
            {site.state && `${site.state}`}
            {site.zip_code && ` ${site.zip_code}`}
          </div>
        </>
      )}
      {site.description && (
        <>
          <strong className="pt-8">Description</strong>
          <div className="pt-2 break-words whitespace-normal" data-testid="description-input">{convertUrlsToLinks(site.description)}</div>
        </>
      )}
      {site.memo && (
        <>
          <strong className="pt-8">Memo</strong>
          <div className="pt-2 break-words whitespace-normal" data-testid="memo-input">{convertUrlsToLinks(site.memo)}</div>
        </>
      )}
      {(primaryContact.name || primaryContact.phone) && (
        <>
          <strong className="pt-8">Primary contact</strong>
          <div className="flex font-sans font-normal gap-10">
            <p className="text-vamos-gray pt-2">{primaryContact.name}</p>
            <p className="pt-2">{primaryContact.phone}</p>
          </div>
        </>
      )}
    </div>
  );
};

SiteStatus.propTypes = {
  site: PropTypes.object.isRequired,
};

export default SiteStatus;
